import './Carousel.scss'
import responsive from '../styles/responsive.module.scss'

import React, { FC } from 'react'
import Slider from 'react-slick'

import CarouselArrow from './CarouselArrow'

const getCurationSetting = (slideSpeed: number) => ({
  dots: false,
  infinite: false,
  speed: slideSpeed,
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {
      breakpoint: parseInt(responsive.max, 10) - 1,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: parseInt(responsive.extraLarge, 10) - 1,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: parseInt(responsive.large, 10) - 1,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: parseInt(responsive.medium, 10) - 1,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: parseInt(responsive.small, 10) - 1,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
  prevArrow: <CarouselArrow direction="prev" />,
  nextArrow: <CarouselArrow direction="next" />,
})

interface Props {
  slideSpeed: number
}

const Carousel: FC<Props> = ({ slideSpeed, children }) => {
  const settings = getCurationSetting(slideSpeed)

  return <Slider {...settings}>{children}</Slider>
}

export default Carousel
